import { HTTPAPI } from "../base";

const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";    
    return token;
}

const users = {
    getList: (urlCriteria) => {        
        return HTTPAPI(grabToken())
        .get("/users" + urlCriteria)
    },
    invite: (data) => {
        return HTTPAPI(grabToken())
        .post("/users/invite", data)
    },
    sendinvitation: (data) => {
        return HTTPAPI(grabToken())
        .post("/users/sendinvitation", data)
    },
    getUser: (code) => {        
        return HTTPAPI(grabToken())
        .get("/users/" + code)
    },
    invite: (data) => {
        return HTTPAPI(grabToken())
        .post("/users/invite", data)
    },
    update: (code, data) => {
        return HTTPAPI(grabToken())
        .patch("/users/" + code, data);
    },
    disable: (code, data) => {
        return HTTPAPI(grabToken())
        .patch("/users/disable/" + code, data);
    },
    reset: (code) => {
        return HTTPAPI(grabToken())
        .get("/users/reset/" + code);
    },
    delete: (code) => {        
        return HTTPAPI(grabToken())
        .delete("/users/delete/" + code)
    },
    
    // signUp: (data) => {
    //     return HTTPAPI()
    //     .post("/users/register", data)
    // },
    // activateUser: (code) => {
    //     return HTTPAPI()
    //     .post("/users/activate", {code})
    // },
    // login: (data) => {
    //     return HTTPAPI()
    //     .post("/auth/login", data)
    // },    
    // logout: (data) => {        
    //     return HTTPAPI(grabToken())
    //     .post("/auth/logout", data)
    // },
    // forgotPass: (data) => {
    //     return HTTPAPI()
    //     .post("/users/forgotpass", data)
    // },
    // validateResetPassCode: (code) => {
    //     return HTTPAPI()
    //     .post("/users/validatepassreset", {code})
    // },
    // changePassword: (data) => {
    //     return HTTPAPI()
    //     .post("/users/changepass", data)
    // }
}

export default users;
